import { useMutation } from '@/hooks/use-api';
import verifyLoginApi from '@/api/post/verify-login';
import Alert from '@/components/alert/alert-component';
import Card from '@/components/card/card-component';
import Loader from '@/components/loader/loader-component';
import PageWrapper from '@/components/page-wrapper/page-wrapper-component';
import { APP_CONTEXT } from '@/utils/context';
import { Heading1Text, Spacer } from '@/utils/global-fonts';
import { jwtDecode } from 'jwt-decode';
import { useContext, useEffect } from 'react';
import { useNavigate, useParams } from 'react-router-dom';

/**
 * Verify user from email link.
 * @returns {JSX.Element} The rendered VerifyLogin page.
 */
const VerifyLogin = () => {
  const navigate = useNavigate();
  const { id } = useParams();
  const { setIsSuper } = useContext(APP_CONTEXT);

  const [verifyUser] = useMutation(verifyLoginApi);

  useEffect(() => {
    verifyUser(id)
      .then(({ data }) => {
        Alert({
          icon: 'success',
          text: 'Login successful',
        });
        const token = jwtDecode(data.jwt);
        setIsSuper(token.is_superuser);
        localStorage.setItem('jwt', data.jwt);
        if (token.type === 'company') {
          navigate('/shop/sales-flow');
        } else {
          navigate('/app/dashboard');
        }
      })
      .catch(() => {
        navigate('/login');
        Alert({
          icon: 'error',
          text: 'Login failed',
        });
      });
  }, [verifyUser, id, navigate, setIsSuper]);

  return (
    <PageWrapper>
      <Card>
        <Heading1Text>Please wait while we are logging you in.</Heading1Text>
        <Spacer $height="50px" />
        <Loader loading />
      </Card>
    </PageWrapper>
  );
};

export default VerifyLogin;
